/**
 * Default SurveyMonkey survey ID (academy-1.0).
 * Override with NEXT_PUBLIC_SURVEY_ID env if needed.
 */
export const DEFAULT_SURVEY_ID =
  process.env.NEXT_PUBLIC_SURVEY_ID ||
  'tRaiETqnLgj758hTBazgdwJ2AI1HHG42fiNjs_2BxoF2DSFztHvwViU3BzcEVmTOQY';

export const DEFAULT_SURVEY_TITLE = 'Survey';
